import { Component, inject } from '@angular/core';
import { BranchesService } from '../services/branches.service';
import { AccessService } from '../../core/services/access.service';
import { BranchesFormComponent } from "../branches-form/branches-form.component";

@Component({
  selector: 'app-branch-create',
  standalone: true,
  imports: [BranchesFormComponent],
  templateUrl: './branch-create.component.html',
  styleUrl: './branch-create.component.css'
})
export class BranchCreateComponent {
  private service = inject(BranchesService)

  protected access = inject(AccessService).access

  ngOnInit(): void {
    this.service.title.update((value) => 'Nueva Sucursal')
  }
}
